import { render, staticRenderFns } from "./orderPreview.vue?vue&type=template&id=059f9e92&scoped=true"
import script from "./orderPreview.vue?vue&type=script&lang=js"
export * from "./orderPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059f9e92",
  null
  
)

export default component.exports